var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _rect, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 67,
    viewBox: "0 0 127 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7391 37.5C57.7391 53.096 45.096 65.7391 29.5 65.7391C13.904 65.7391 1.26092 53.096 1.26092 37.5C1.26092 21.904 13.904 9.26091 29.5 9.26091C45.096 9.26091 57.7391 21.904 57.7391 37.5Z",
    stroke: "url(#paint0_linear_474_6215)",
    strokeWidth: 2.52185
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6063 37.5C45.6063 46.3942 38.3961 53.6043 29.502 53.6043C20.6078 53.6043 13.3976 46.3942 13.3976 37.5C13.3976 28.6058 20.6078 21.3957 29.502 21.3957C38.3961 21.3957 45.6063 28.6058 45.6063 37.5Z",
    stroke: "url(#paint1_linear_474_6215)",
    strokeWidth: 2.52185
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4203 9.1507C41.4203 13.134 38.1911 16.3632 34.2078 16.3632C30.2244 16.3632 26.9953 13.134 26.9953 9.1507C26.9953 5.16735 30.2244 1.93822 34.2078 1.93822C38.1911 1.93822 41.4203 5.16735 41.4203 9.1507Z",
    fill: "url(#paint2_linear_474_6215)",
    stroke: "#081B3E",
    strokeWidth: 2.52185
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.198 37.5C18.198 39.8089 16.3263 41.6806 14.0174 41.6806C11.7085 41.6806 9.83671 39.8089 9.83671 37.5C9.83671 35.1911 11.7085 33.3193 14.0174 33.3193C16.3263 33.3193 18.198 35.1911 18.198 37.5Z",
    fill: "url(#paint3_linear_474_6215)",
    stroke: "#081B3E",
    strokeWidth: 1.68123
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5691 60.5142C17.5691 62.8231 15.6974 64.6949 13.3885 64.6949C11.0795 64.6949 9.2078 62.8231 9.2078 60.5142C9.2078 58.2053 11.0795 56.3335 13.3885 56.3335C15.6974 56.3335 17.5691 58.2053 17.5691 60.5142Z",
    fill: "url(#paint4_linear_474_6215)",
    stroke: "#081B3E",
    strokeWidth: 1.68123
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5993,
    cy: 24.8422,
    r: 3.23917,
    fill: "url(#paint5_linear_474_6215)",
    stroke: "#081B3E",
    strokeWidth: 1.68123
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.6023,
    cy: 50.1578,
    r: 2.57042,
    fill: "url(#paint6_linear_474_6215)",
    stroke: "#081B3E",
    strokeWidth: 1.34499
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 16,
    transform: "translate(22 30)",
    fill: "#081B3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.28 44V32.48H25.208V42.192H30.296V44H23.28ZM39.4913 44.24C38.5739 44.24 37.7659 44.0533 37.0673 43.68C36.3739 43.3067 35.8299 42.7813 35.4352 42.104C35.0459 41.4267 34.8512 40.632 34.8512 39.72V32.496L36.8032 32.48V39.672C36.8032 40.104 36.8752 40.4907 37.0192 40.832C37.1686 41.1733 37.3686 41.464 37.6193 41.704C37.8699 41.9387 38.1579 42.1173 38.4833 42.24C38.8086 42.3627 39.1446 42.424 39.4913 42.424C39.8486 42.424 40.1873 42.3627 40.5073 42.24C40.8326 42.112 41.1206 41.9307 41.3713 41.696C41.6219 41.456 41.8193 41.1653 41.9633 40.824C42.1072 40.4827 42.1792 40.0987 42.1792 39.672V32.48H44.1313V39.72C44.1313 40.632 43.9339 41.4267 43.5393 42.104C43.1499 42.7813 42.6059 43.3067 41.9073 43.68C41.2139 44.0533 40.4086 44.24 39.4913 44.24ZM48.6069 44L52.5109 38.176L48.7189 32.48H51.0789L53.7029 36.536L56.3029 32.48H58.6789L54.8869 38.176L58.7749 44H56.4149L53.7029 39.816L50.9829 44H48.6069Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8272 44.24C66.9899 44.24 66.2459 44.096 65.5952 43.808C64.9499 43.52 64.4059 43.112 63.9632 42.584C63.5206 42.056 63.1846 41.424 62.9552 40.688C62.7259 39.952 62.6112 39.136 62.6112 38.24C62.6112 37.0507 62.8112 36.008 63.2112 35.112C63.6166 34.2107 64.2059 33.5093 64.9792 33.008C65.7526 32.5067 66.7019 32.256 67.8272 32.256C68.9899 32.256 69.9446 32.528 70.6912 33.072C71.4432 33.616 71.9712 34.3307 72.2752 35.216L71.3632 35.496C71.0966 34.7867 70.6619 34.2213 70.0592 33.8C69.4619 33.3733 68.7259 33.1573 67.8512 33.152C66.9072 33.152 66.1206 33.368 65.4912 33.8C64.8672 34.2267 64.3979 34.824 64.0832 35.592C63.7686 36.36 63.6059 37.2427 63.5952 38.24C63.5846 39.2373 63.7366 40.12 64.0512 40.888C64.3712 41.6507 64.8486 42.2507 65.4832 42.688C66.1179 43.12 66.9072 43.336 67.8512 43.336C68.7526 43.3413 69.4886 43.1653 70.0592 42.808C70.6352 42.4507 71.0619 41.9493 71.3392 41.304C71.6219 40.6533 71.7739 39.8933 71.7952 39.024H68.9312V38.184H72.7552C72.7712 38.3173 72.7792 38.448 72.7792 38.576C72.7846 38.704 72.7872 38.8027 72.7872 38.872C72.7872 39.8907 72.6086 40.8053 72.2512 41.616C71.8992 42.4267 71.3552 43.0667 70.6192 43.536C69.8886 44.0053 68.9579 44.24 67.8272 44.24ZM75.1919 44V32.48H79.5359C79.6479 32.48 79.7679 32.4853 79.8959 32.496C80.0292 32.5013 80.1679 32.5173 80.3119 32.544C80.8879 32.6347 81.3812 32.8427 81.7919 33.168C82.2079 33.488 82.5252 33.8933 82.7439 34.384C82.9625 34.8693 83.0719 35.4053 83.0719 35.992C83.0719 36.84 82.8452 37.5787 82.3919 38.208C81.9385 38.8373 81.3065 39.2373 80.4959 39.408L80.2319 39.512H76.1119V44H75.1919ZM82.2879 44L80.0159 39.312L80.8719 38.88L83.3679 44H82.2879ZM76.1119 38.608H79.5199C79.6159 38.608 79.7252 38.6027 79.8479 38.592C79.9759 38.5813 80.1039 38.5653 80.2319 38.544C80.6479 38.4587 80.9945 38.2907 81.2719 38.04C81.5492 37.784 81.7572 37.4773 81.8959 37.12C82.0345 36.7627 82.1039 36.3867 82.1039 35.992C82.1039 35.5973 82.0345 35.224 81.8959 34.872C81.7572 34.5147 81.5492 34.2107 81.2719 33.96C80.9945 33.704 80.6479 33.5333 80.2319 33.448C80.1039 33.4213 79.9759 33.4027 79.8479 33.392C79.7252 33.3813 79.6159 33.376 79.5199 33.376H76.1119V38.608ZM90.3774 44.24C89.5134 44.24 88.7454 44.0613 88.0734 43.704C87.4067 43.3413 86.8814 42.8347 86.4974 42.184C86.1187 41.528 85.9294 40.76 85.9294 39.88V32.48H86.8574V39.688C86.8574 40.344 86.9667 40.9067 87.1854 41.376C87.4094 41.84 87.6974 42.2187 88.0494 42.512C88.4067 42.8053 88.788 43.0213 89.1934 43.16C89.604 43.2987 89.9987 43.368 90.3774 43.368C90.756 43.368 91.1507 43.2987 91.5614 43.16C91.972 43.0213 92.3534 42.8053 92.7054 42.512C93.0574 42.2187 93.3427 41.84 93.5614 41.376C93.7854 40.9067 93.8974 40.344 93.8974 39.688V32.48H94.8254V39.88C94.8254 40.7547 94.6334 41.52 94.2494 42.176C93.8707 42.8267 93.3454 43.3333 92.6734 43.696C92.0067 44.0587 91.2414 44.24 90.3774 44.24ZM97.87 44V32.48H102.214C102.326 32.48 102.446 32.4853 102.574 32.496C102.707 32.5013 102.846 32.5173 102.99 32.544C103.566 32.6347 104.059 32.8427 104.47 33.168C104.886 33.488 105.203 33.8933 105.422 34.384C105.641 34.8693 105.75 35.4053 105.75 35.992C105.75 36.584 105.641 37.1253 105.422 37.616C105.203 38.1013 104.886 38.5067 104.47 38.832C104.059 39.152 103.566 39.3573 102.99 39.448C102.846 39.4693 102.707 39.4853 102.574 39.496C102.446 39.5067 102.326 39.512 102.214 39.512H98.79V44H97.87ZM98.79 38.608H102.198C102.294 38.608 102.403 38.6027 102.526 38.592C102.654 38.5813 102.782 38.5653 102.91 38.544C103.326 38.4587 103.673 38.2907 103.95 38.04C104.227 37.784 104.435 37.4773 104.574 37.12C104.713 36.7627 104.782 36.3867 104.782 35.992C104.782 35.5973 104.713 35.224 104.574 34.872C104.435 34.5147 104.227 34.2107 103.95 33.96C103.673 33.704 103.326 33.5333 102.91 33.448C102.782 33.4213 102.654 33.4027 102.526 33.392C102.403 33.3813 102.294 33.376 102.198 33.376H98.79V38.608ZM108.154 44V32.48H112.498C112.61 32.48 112.73 32.4853 112.858 32.496C112.992 32.5013 113.13 32.5173 113.274 32.544C113.85 32.6347 114.344 32.8427 114.754 33.168C115.17 33.488 115.488 33.8933 115.706 34.384C115.925 34.8693 116.034 35.4053 116.034 35.992C116.034 36.584 115.925 37.1253 115.706 37.616C115.488 38.1013 115.17 38.5067 114.754 38.832C114.344 39.152 113.85 39.3573 113.274 39.448C113.13 39.4693 112.992 39.4853 112.858 39.496C112.73 39.5067 112.61 39.512 112.498 39.512H109.074V44H108.154ZM109.074 38.608H112.482C112.578 38.608 112.688 38.6027 112.81 38.592C112.938 38.5813 113.066 38.5653 113.194 38.544C113.61 38.4587 113.957 38.2907 114.234 38.04C114.512 37.784 114.72 37.4773 114.858 37.12C114.997 36.7627 115.066 36.3867 115.066 35.992C115.066 35.5973 114.997 35.224 114.858 34.872C114.72 34.5147 114.512 34.2107 114.234 33.96C113.957 33.704 113.61 33.5333 113.194 33.448C113.066 33.4213 112.938 33.4027 112.81 33.392C112.688 33.3813 112.578 33.376 112.482 33.376H109.074V38.608ZM118.439 44V32.48H125.559V33.376H119.359V37.752H124.599V38.648H119.359V43.104H125.559V44H118.439Z",
    fill: "#307BDF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_474_6215",
    x1: 46.8711,
    y1: 7.99998,
    x2: 7.60626,
    y2: 63.8136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_474_6215",
    x1: 39.7275,
    y1: 20.1347,
    x2: 16.6142,
    y2: 52.9896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4793FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_474_6215",
    x1: 41.7397,
    y1: -0.996467,
    x2: 31.4879,
    y2: 17.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C53B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_474_6215",
    x1: 18.4807,
    y1: 31.4868,
    x2: 12.4056,
    y2: 42.5213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C53B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_474_6215",
    x1: 17.8518,
    y1: 54.5011,
    x2: 11.7767,
    y2: 65.5355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C53B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_474_6215",
    x1: 42.2258,
    y1: 19.9565,
    x2: 37.2898,
    y2: 28.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C53B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_474_6215",
    x1: 41.4849,
    y1: 46.2743,
    x2: 37.5614,
    y2: 53.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C53B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1016e6b0a82a694837a16e45af4e37e8.svg";
export { ForwardRef as ReactComponent };